<template>
	<div v-if="reduce" class="app-header-logo" :title="title"><span class="app-logo"><span class="logo-secondary">grm</span></span></div>
	<div v-else class="app-header-logo" :title="title"><span class="app-logo"><span class="logo-primary">intouch</span> <span class="logo-secondary">grm</span></span></div>
</template>

<script setup lang="ts">
import {ref, computed} from "vue";

const props = withDefaults(defineProps<{
	title?: string,
	reduce?: boolean
}>(), { title: "", reduce: false });
</script>

<style>
.app-header-logo {
	white-space: nowrap;
}

.app-logo {
	font-family: AnnecaSymbols;
	font-size: 19px;
	border: 0;
	background-image: var(--url-logo);
	background-repeat: no-repeat;
}

.logo-primary {
	color: var(--logo-primary-fg);
}
.logo-secondary {
	color: var(--logo-secondary-fg);
}
</style>